import React from 'react';
import {actionIcCheckCircle24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {currentResource, labels} from '../../../../util/utils';
import Assertions from '../../Assertions/Assertions';
import Icon from '../../BaseComponentWrappers/MotifIcon';

const AssociatedRiskAccountItem = (props) => {
	const getCurrentStatementType = (id) => {
		return currentResource.statementTypes.find((x) => x.id === props.statementTypeId).name;
	};
	return (
		<>
			<section className="related-accountassertion">
				<span className="relatedaccounts-name">
					<Icon src={actionIcCheckCircle24px} />
					{props.printView ? '' : labels.accountLabel + ' - '}
				</span>
				<span className="account-name" title={props.accountName}>
					{props.accountName}
				</span>
				<span className="statement-type" title={getCurrentStatementType(props.statementTypeId)}>
					{getCurrentStatementType(props.statementTypeId)}
				</span>
				<section className="assertions-container">
					<Assertions assertions={props.selectedAssertions} />
				</section>
			</section>
		</>
	);
};

export default AssociatedRiskAccountItem;
